import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase } from 'lucide-react';
import UserLayout from './UserLayout';
import OccupationsSkillsPanel from '../OccupationsSkillsPanel';
import { useLanguage } from '../../context/LanguageContext';
import { logout } from '../../services/authService';

/**
 * OccupationsPage - Full page for managing occupations and skills
 */
const OccupationsPage = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const userUuid = localStorage.getItem('userUuid');

    const handleLogout = async () => {
        await logout();
        localStorage.clear();
        navigate('/login');
    };

    const handleNavigate = (page) => {
        // Navigate to dashboard with the requested page
        // The dashboard will handle showing the correct component
        navigate('/', { state: { page } });
    };

    const translations = {
        fr: {
            title: 'Mes métiers et compétences',
            subtitle: 'Gérez vos métiers ESCO et sélectionnez vos compétences'
        },
        en: {
            title: 'My occupations and skills',
            subtitle: 'Manage your ESCO occupations and select your skills'
        },
        nl: {
            title: 'Mijn beroepen en vaardigheden',
            subtitle: 'Beheer uw ESCO-beroepen en selecteer uw vaardigheden'
        },
        de: {
            title: 'Meine Berufe und Fähigkeiten',
            subtitle: 'Verwalten Sie Ihre ESCO-Berufe und wählen Sie Ihre Fähigkeiten'
        }
    };

    const t = translations[language] || translations.fr;

    return (
        <UserLayout
            currentPage="occupations"
            onNavigate={handleNavigate}
            onLogout={handleLogout}
        >
            {/* Page Header */}
            <div className="mb-6">
                <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gradient-to-r from-cabaza-purple to-cabaza-pink rounded-xl flex items-center justify-center">
                        <Briefcase className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">{t.title}</h1>
                        <p className="text-gray-500 text-sm">{t.subtitle}</p>
                    </div>
                </div>
            </div>

            {/* Content */}
            <OccupationsSkillsPanel
                peopleUuid={userUuid}
                language={language}
            />
        </UserLayout>
    );
};

export default OccupationsPage;
